import Divisi from "./Divisi";
import Posisi from "./Posisi";
import UserRole from "./UserRole";
import BaseModel from "./_BaseModel";

export default class Karyawan extends BaseModel {
    public readonly ucode?: string;
    public kode?: string;
    public nama?: string;
    public alamat?: string;
    public telp?: string;
    public email?: string;
    public aktif?: boolean = true;
    public keterangan?: string;
    public ucode_divisi?: string;
    public divisi?: Divisi;
    public ucode_posisi?: string;
    public posisi?: Posisi;

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
}